
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-for-professional",
      function () {
        return require("private-next-pages/terms-for-professional.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-for-professional"])
      });
    }
  